import * as React from 'react';
import classnames from 'classnames';
import { ICoreContext } from '@msdyn365-commerce/core';
import { IProductInventoryInformation } from '@msdyn365-commerce-modules/retail-actions';

export interface IAvailabilityProps {
    baseClassName: string;
    context: ICoreContext;
    availability?: IProductInventoryInformation;
}

export const Availability: React.FC<IAvailabilityProps> = ({ baseClassName, context, availability }) => {
    let availabilityClass = availability ? 'not-available' : 'retrieving';

    if (availability?.StockLevelLabel?.startsWith('!') || availability?.IsProductAvailable) {
        availabilityClass = 'available';
    }

    if (availability?.StockLevelCode === 'ERR') {
        availabilityClass = 'error';
    }

    const randomShimmerWidth = React.useMemo(() => Math.floor(Math.random() * (230 - 82 + 1)) + 82, []);

    const stockLevelLabel = availability?.StockLevelLabel?.startsWith('!')
        ? availability?.StockLevelLabel?.substring(1)
        : availability?.StockLevelLabel;
    const availabilityText = stockLevelLabel || (availabilityClass === 'error' ? 'ERROR' : '');

    return (
        <div className={classnames(`${baseClassName}__details__availability`, availabilityClass)} data-shimmer-width={randomShimmerWidth}>
            <div className={`${baseClassName}__details__availability__indicator`} />
            <span>{availabilityText}</span>
        </div>
    );
};
